/**
 * Main Module
 * 
 * This is the main entry point for the AS Components library.
 * It re-exports all important functions and types from the exports.ts file.
 * 
 * Users can import directly from this file:
 * import { reactiveStore } from 'as-components.v0.0.10.m.js';
 */


// Use a setter to detect when verbose is enabled
let _verbose = false;
Object.defineProperty(window, 'verbose', {
  get: () => _verbose,
  set: (value: boolean) => {
    _verbose = value;
    if (value === true) {
      console.log('%c[AS-COMPONENTS] Verbose ON', 'color: #4CAF50; font-weight: bold;');
    }
  },
  configurable: true
});

window.devlogTraces = false
window.fakeProduction = false

// Import global styles
import './as-components.css';

// Import components to register them. Must run before the exports.ts
// re-export below: several of exports.ts's re-exported classes (e.g.
// AsExportGroup) upgrade already-parsed custom elements the instant their
// module evaluates, which reads plugin-registered state (ExportBuilder button
// descriptors, etc.) synchronously in their connectedCallback. If exports.ts
// evaluated first, those upgrades would race ahead of the plugin
// registrations enabledComponents.ts triggers (e.g. grabcadPlugin.ts),
// permanently baking in a button list from before the plugin registered.
import './components/enabledComponents.ts';
import { detectDeviceInfo } from './util/utils.ts';
import './features/history/historyDebugPanel.ts';

// Re-export everything from exports.ts
export * from './exports.ts';

// Check if we're in development mode (either dev server or development build)
if (import.meta.env.DEV || import.meta.env.BUILD_DEV) {
  console.log('AS Components is running in development mode', import.meta.env);
}

